"use client";

import Button from "@/components/library/Button";
import { useAnchorClickHandler } from "@/hooks/useAnchorClickHandler";
import {
  getCtaAlignmentClassName,
  type CtaAlignment,
} from "@/utils/ctaAlignment";
import { opensInNewBrowserTab } from "@/utils/isExternalUrl";

const TYPE_MAP = {
  primary: "secondary",
  demo: "primary",
} as const;

interface CTAProps {
  type?: "primary" | "demo";
  link: string;
  text: string;
  align?: CtaAlignment;
}

export function CTA({
  type = "primary",
  link,
  text,
  align = "center",
}: Readonly<CTAProps>) {
  const openInNewTab = opensInNewBrowserTab(link);
  const handleAnchorClick = useAnchorClickHandler(link);

  return (
    <div
      className={`not-prose my-8 flex ${getCtaAlignmentClassName(align)}`}
    >
      <Button
        href={link}
        type={TYPE_MAP[type]}
        target={openInNewTab ? "_blank" : undefined}
        rel={openInNewTab ? "noopener noreferrer" : undefined}
        onClick={openInNewTab ? undefined : handleAnchorClick}
      >
        {text}
      </Button>
    </div>
  );
}
